import { render, staticRenderFns } from "./LayoutHistoryItem.vue?vue&type=template&id=1c1593d6&scoped=true"
import script from "./LayoutHistoryItem.vue?vue&type=script&lang=js"
export * from "./LayoutHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./LayoutHistoryItem.vue?vue&type=style&index=0&id=1c1593d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1593d6",
  null
  
)

export default component.exports